<template>
  <div>
    <b-form-group label="UserName" label-for="username">
      <b-form-input id="username" v-model="resource.username" required></b-form-input>
    </b-form-group>
    <b-form-group label="Password" label-for="password">
      <b-form-input id="password" v-model="resource.password" type="password" required></b-form-input>
    </b-form-group>
    <b-form-group label="Database (Optional)" label-for="database">
      <b-form-input id="database" v-model="resource.database" type="text" placeholder="Leave empty to connect to default database"></b-form-input>
    </b-form-group>
    <p class="text-muted">Passwords are saved in a secret store and cannot be retrieved once saved.</p>
  </div>
</template>

<script>
export default {
  props: ['resource'],
};
</script>
